export type Sortable = string | number | boolean | null | undefined

// Normalizes dd/mm/yyyy (or dd-mm-yyyy, dd.mm.yyyy) to yyyy/mm/dd so that
// date strings sort chronologically. This handles extra_data columns that
// contain user-entered dates without a _raw counterpart.
const DATE_PATTERN = /(\d\d?)[-/.](\d\d?)[-/.](\d{4})/
function normalizeDates(value: string): string {
  return value.replace(
    DATE_PATTERN,
    (_match, day, month, year) => `${year}/${month}/${day}`
  )
}

function localeStringCompare(a: Sortable, b: Sortable): number {
  const strA = normalizeDates(String(a ?? ''))
  const strB = normalizeDates(String(b ?? ''))
  return strA.localeCompare(strB, undefined, {
    numeric: true,
    sensitivity: 'base',
  })
}

// Attempts numeric comparison: if both values are numbers or numeric strings,
// compares mathematically. Returns null if either value is non-numeric.
function numericCompare(a: Sortable, b: Sortable): number | null {
  const numA = typeof a === 'number' ? a : Number(a)
  const numB = typeof b === 'number' ? b : Number(b)
  if (isNaN(numA) || isNaN(numB)) return null
  return numA - numB
}

// Numeric comparison when both values are numbers or numeric strings,
// otherwise delegate to string comparison. This ensures negative numbers
// sort mathematically (e.g. -1500 < -1400, "-50" < "0").
export function compareValues(a: Sortable, b: Sortable): number {
  return numericCompare(a, b) ?? localeStringCompare(a, b)
}
